/**
 * PHAT LAI DANH SACH LENH THANH DANH SACH CHU THICH.
 *
 * Ham THUAN TUY, khong cham vao byte. Day la ADR-003 ap dung cho chu thich, y
 * het replayPagePlan() lam voi thao tac trang:
 *
 *      chu thich hien hanh = fold(danh sach EditCommand)
 *
 * Vi sao dieu nay quan trong hon no ve: kho trang thai o tang giao dien
 * (state/store.ts applyToProjection) da co mot phep fold GIONG HET. Neu duong
 * ghi tu fold theo cach rieng, hai ban se troi khoi nhau va nguoi dung se xuat
 * ra mot tep khac voi thu ho dang nhin. Nen duong ghi goi HAM NAY, va bo test
 * doi chieu ket qua cua no voi ket qua cua kho trang thai.
 *
 * THU TU TRA VE la thu tu chong lop theo `z`, KHONG phai thu tu them vao.
 *
 * Truoc day ham nay tra ve theo thu tu them vao, va do la mot loi that: nguoi
 * dung doi cho hai doi tuong trong bang, bang doi cho ngay, nhung tep xuat ra
 * van ghi /Annots theo thu tu cu - hai hinh chong nhau y nhu truoc khi doi.
 * Xem core/annotations/order.ts.
 */
import type { Annotation, EditCommand } from '@pdfeditor/types';
import { sortAnnotationsByZ } from './order';

/** Ap cac lenh chu thich len mot danh sach rong. Lenh khac bi bo qua. */
export function replayAnnotations(commands: readonly EditCommand[]): Annotation[] {
  // Map giu duoc CA thu tu chen lan dau lan viec tra cuu theo ma trong O(1).
  const byId = new Map<string, Annotation>();

  for (const command of commands) {
    switch (command.kind) {
      case 'annotation.add':
        // Ghi de khi trung ma la co y: phat lai mot lenh 'add' da co (redo sau
        // undo) phai cho ra dung mot doi tuong, khong phai hai.
        byId.set(command.annotation.id, { ...command.annotation });
        break;

      case 'annotation.remove':
        byId.delete(command.id);
        break;

      case 'annotation.update': {
        const previous = byId.get(command.id);
        // Vá mot chu thich khong con ton tai la lenh vo nghia, KHONG phai lenh
        // tao moi: tao moi tu mot Partial<Annotation> se cho ra mot doi tuong
        // thieu truong bat buoc.
        if (!previous) break;
        byId.set(command.id, { ...previous, ...command.patch, id: previous.id });
        break;
      }

      default:
        break;
    }
  }

  // Sap theo `z` LA BUOC BAT BUOC, khong phai trang tri: `byId` giu thu tu them
  // vao, con thu tu ma nguoi dung nhin thay va sap xep lai la thu tu `z`.
  return sortAnnotationsByZ([...byId.values()]);
}

/** So lenh chu thich trong danh sach - giao dien dung de dem thao tac cho luu. */
export function countAnnotationCommands(commands: readonly EditCommand[]): number {
  return commands.filter(
    (c) =>
      c.kind === 'annotation.add' ||
      c.kind === 'annotation.update' ||
      c.kind === 'annotation.remove',
  ).length;
}

export function isAnnotationCommand(command: EditCommand): boolean {
  return (
    command.kind === 'annotation.add' ||
    command.kind === 'annotation.update' ||
    command.kind === 'annotation.remove'
  );
}
